'use client';

import Image from 'next/image';
import { Carousel, CarouselCaption, CarouselItem } from 'react-bootstrap';
import styles from './HeroSection.module.css';

const slides = [
  {
    src: '/assets/bg.webp',
    text1: 'The heartbeat of Kerala ',
    text2: 'resonates',
    text3: 'in every Blasters match!',
  },
];

const HeroSection = () => {
  return (
    <Carousel controls={false} interval={3000} fade className={styles.carousel}>
      {slides.map((slide, index) => (
        <CarouselItem
          key={index}
          className={styles.carouselItem}
          style={{ height: '95vh' }}
        >
          <div className={styles.carouselImageContainer}>
            <Image
              className={`d-block w-100 ${styles.carouselImage}`}
              src={slide.src}
              alt={`Slide ${index + 1}`}
              height={720}
              width={720}
              priority
              loading="eager"
              data-aos="zoom-in"
              data-aos-offset="0"
            />
          </div>
          <CarouselCaption className={styles.carouselCaption}>
            <div className={styles.carouselDiv}>
              <h3
                className={styles.captionHeading}
                data-aos="zoom-out"
                data-aos-duration="1500"
                data-aos-offset="0"
              >
                {slide.text1}
                <span className="yellow-span">{slide.text2} </span>
                {slide.text3}
              </h3>
            </div>
          </CarouselCaption>
        </CarouselItem>
      ))}
    </Carousel>
  );
};

export default HeroSection;
